<template>
  <div class="home">
    <Header></Header>
    <Asider></Asider>
    <div class="main-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Asider from '@/components/Asider.vue'
export default {
  name: 'home',
  components: {
    Header,
    Asider
  }
}
</script>

<style>
.main-wrap {
  margin-left: 170px;
  position: absolute;
  top: 52px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
</style>
